import { ApiResponse } from "./types"
import { Dayjs } from "src/utils/dayjs"

export enum OperationStatusEnum {
  existedAndNoChange = 0,
  existedAndChanged = 1,
  existedAndDeleted = 2,
  new = 3
}

export interface ReviewAndSendData {
  showId: number;
  parentAllocationId?: number;
  allocations: AllocationData[];
}

export enum AllocationTypeEnum {
  generic = "Generic",
  vip = "VIP",
  friendsAndFamily = "FriendsAndFamily",
  priority = "Priority"
}

export enum ManagerPermissionEnum {
  allocate = 1,
  view = 2,
  send = 3
}

export interface AllocationData {
    id?: number;
    name: string;
    type?: AllocationTypeEnum;
    errors?: {
        name?: boolean;
        type?: boolean;
    }
    operatingStatus: OperationStatusEnum;
    managers?: ManagerData[];
    tickets?: TicketSessionData[];
    deadlines?: DeadlineSessionData[];
}

export interface ManagerUser {
  userId?: string;
  email: string;
  firstName?: string;
  lastName?: string;
}

export interface ManagerData extends ManagerUser {
  permission: ManagerPermissionEnum;
  operatingStatus: OperationStatusEnum;
}

export interface TicketSessionData {
  sessionId: number;
  numberOfTickets: number;
  operatingStatus: OperationStatusEnum;
}

export interface DeadlineOffsetData {
  original: number;
  current: number;
  operatingStatus: OperationStatusEnum;
}

export interface DeadlineSessionData {
  sessionId: number;
  original: number;
  deadline: number;
  arrivalTime: Dayjs;
  operatingStatus: OperationStatusEnum;
}

export interface Allocation {
    allocationId: number;
    allocationName: string;
    magicLink: string | undefined;
}

export class ReviewAndSendResponse extends ApiResponse<Allocation[]> { }
